export var DatePickerCellStatusProp = /*#__PURE__*/function (DatePickerCellStatusProp) {
  DatePickerCellStatusProp["Normal"] = "Normal";
  DatePickerCellStatusProp["Block"] = "Block";
  DatePickerCellStatusProp["CheckoutOnly"] = "CheckoutOnly";
  DatePickerCellStatusProp["UnavailableDueToMinimumStay"] = "UnavailableDueToMinimumStay";
  return DatePickerCellStatusProp;
}({});